import { useCallback } from 'react';
import { listKiosks } from '../services/kioskAdminService';
import { KIOSK_STATUS, type KioskListFilters, type KioskRecord } from '../types/kiosk';
import { kioskAdminErrorMessage } from '../utils/kioskErrors';
import { usePaginatedMasterData } from './usePaginatedMasterData';

export function useKiosks() {
  const loadPage = useCallback(
    async (args: {
      page: number;
      pageSize: number;
      search: string;
      filters: KioskListFilters;
    }) => {
      try {
        return await listKiosks({
          page: args.page,
          pageSize: args.pageSize,
          filters: args.filters,
        });
      } catch (error) {
        throw Object.assign(
          new Error(
            kioskAdminErrorMessage(error, 'Unable to load kiosks.'),
          ),
          error,
        );
      }
    },
    [],
  );

  return usePaginatedMasterData<KioskRecord, KioskListFilters>({
    getId: item => item.kioskId,
    loadPage,
    initialFilters: { status: KIOSK_STATUS.ACTIVE },
    errorMessage: 'Unable to load kiosks.',
  });
}
